export default "__VITE_ASSET__Lz_ffoeb__"